import { Controller } from '@hotwired/stimulus'

// Crossfade hero banner slides. Single image = static (controller no-ops).
export default class extends Controller {
  static targets = ['slide', 'dot']

  static values = {
    interval: { type: Number, default: 6000 }
  }

  connect () {
    if (this.slideTargets.length < 2) return

    this.index = 0
    this.show(0)
    this.start()

    this.pauseOnHover = this.pauseOnHover.bind(this)
    this.resumeOnLeave = this.resumeOnLeave.bind(this)
    this.element.addEventListener('mouseenter', this.pauseOnHover)
    this.element.addEventListener('mouseleave', this.resumeOnLeave)
  }

  disconnect () {
    this.stop()
    this.element.removeEventListener('mouseenter', this.pauseOnHover)
    this.element.removeEventListener('mouseleave', this.resumeOnLeave)
  }

  pauseOnHover () {
    this.stop()
  }

  resumeOnLeave () {
    if (this.slideTargets.length < 2) return
    this.start()
  }

  goTo (event) {
    const index = Number(event.currentTarget.dataset.heroCarouselIndex)
    if (Number.isNaN(index)) return

    this.index = index
    this.show(index)
    this.restart()
  }

  previous (event) {
    event?.preventDefault()
    event?.stopPropagation()
    if (this.slideTargets.length < 2) return

    this.index = (this.index - 1 + this.slideTargets.length) % this.slideTargets.length
    this.show(this.index)
    this.restart()
  }

  next (event) {
    event?.preventDefault()
    event?.stopPropagation()
    if (this.slideTargets.length < 2) return

    this.advance()
    this.restart()
  }

  restart () {
    this.stop()
    this.start()
  }

  advance () {
    this.index = (this.index + 1) % this.slideTargets.length
    this.show(this.index)
  }

  show (index) {
    this.slideTargets.forEach((slide, i) => {
      const active = i === index
      slide.classList.toggle('opacity-100', active)
      slide.classList.toggle('opacity-0', !active)
      slide.classList.toggle('z-10', active)
      slide.classList.toggle('z-0', !active)
      slide.setAttribute('aria-hidden', active ? 'false' : 'true')
    })

    if (this.hasDotTarget) {
      this.dotTargets.forEach((dot, i) => {
        const active = i === index
        dot.setAttribute('aria-current', active ? 'true' : 'false')
        dot.classList.toggle('bg-white', active)
        dot.classList.toggle('w-5', active)
        dot.classList.toggle('bg-white/45', !active)
        dot.classList.toggle('w-1.5', !active)
      })
    }
  }

  start () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    this.stop()
    this.timer = window.setInterval(() => this.advance(), this.intervalValue)
  }

  stop () {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }
}
